<div class="tour-title-wrapper">
    <span multilang class="tour-title">Ausstattung</span>
</div>
<div class="tour-wrapper" *ngIf="facilityList?.length > 0">
    <ng-container *ngFor="let op of facilityList | slice:0:slicenbr">
        <button class="tour-item-wrapper" (click)="selected(op)" matRipple>
            @if(selectedList.indexOf(op.code) >= 0){
            <img src="../../../../../assets/icons/tickedcheckbox.png" alt="">
            }@else{
            <img src="../../../../../assets/icons/checkbox.png" alt="">
            }
            <span multilang class="tour-item-name">{{op.name}}</span>
        </button>
    </ng-container>
    <ng-container *ngIf="facilityList.length > 5">
        <ng-container *ngIf="(slicenbr < facilityList.length) else less">
            <button class="showallbtn" (click)="showMore(facilityList.length)" matRipple>
                <span multilang>alle {{facilityList.length}} anzeigen</span>
            </button>
        </ng-container>
        <ng-template #less>
            <button class="showallbtn" (click)="showMore(5)" matRipple>
                <span multilang>weniger anzeigen</span>
            </button>
        </ng-template>
    </ng-container>
</div>